/*
 * Botón "Compartir" en la ficha de producto (estética Capelli USA).
 * Etiqueta con la MISMA fuente que los tabs de acordeón (cuerpo = Inter, 14px, weight 500,
 * color #1c1c1c); ícono relleno idéntico al de Capelli (share nativo).
 * Se inserta justo debajo del bloque de descripción/acordeones.
 * Dispara la Web Share API (navigator.share); fallback: copia el enlace al portapapeles.
 */
(function () {
  var CSS =
    '.cap-share{display:inline-flex;align-items:center;gap:8px;background:none;border:0;' +
    'padding:16px 0;margin:0;cursor:pointer;color:#1c1c1c;-webkit-appearance:none;}' +
    '.cap-share__label{font-family:var(--font-body--family,"Inter",sans-serif);' +
    'font-size:14px;font-weight:400;letter-spacing:normal;line-height:1;text-transform:none;color:inherit;}' +
    '.cap-share__icon{width:20px!important;height:20px!important;display:block;flex:0 0 auto;color:inherit;}' +
    '.cap-share:hover{opacity:0.65;}' +
    '.cap-share__toast{margin-inline-start:10px;font-family:var(--font-body--family,"Inter",sans-serif);' +
    'font-size:13px;letter-spacing:normal;color:#6b6b6b;opacity:0;transition:opacity .2s ease;}' +
    '.cap-share__toast.is-visible{opacity:1;}';

  var ICON =
    '<svg class="cap-share__icon" aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 20 20">' +
    '<path fill="currentColor" d="M10.75 12.75a.75.75 0 0 1-1.5 0V6.06L8.03 7.28a.75.75 0 0 1-1.06-1.06l2.5-2.5a.75.75 0 0 1 1.06 0l2.5 2.5a.75.75 0 0 1-1.06 1.06l-1.22-1.22v6.69Z"></path>' +
    '<path fill="currentColor" d="M16.5 10.25A2.25 2.25 0 0 0 14.25 8h-.07a.75.75 0 0 0 0 1.5h.07a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75h-8.5a.75.75 0 0 1-.75-.75v-4a.75.75 0 0 1 .75-.75h.07a.75.75 0 0 0 0-1.5h-.07a2.25 2.25 0 0 0-2.25 2.25v4a2.25 2.25 0 0 0 2.25 2.25h8.5a2.25 2.25 0 0 0 2.25-2.25v-4Z"></path>' +
    '</svg>';

  function injectCSS() {
    if (document.getElementById('cap-share-css')) return;
    var s = document.createElement('style');
    s.id = 'cap-share-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function cleanUrl() {
    return location.origin + location.pathname;
  }
  function productTitle() {
    var h1 = document.querySelector('.product-information h1, main h1, h1');
    return h1 ? h1.textContent.trim() : document.title;
  }

  function build() {
    if (document.querySelector('.cap-share')) return; // una sola vez por página
    // Anclar al bloque de descripción del producto (contiene los acordeones).
    var block =
      document.querySelector('[class*="text_aEtTtq"]') ||
      (document.querySelector('.cap-accordions') || {}).parentElement;
    if (!block) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cap-share';
    btn.setAttribute('aria-label', 'Compartir este producto');
    btn.innerHTML =
      '<span class="cap-share__label">Compartir</span>' + ICON +
      '<span class="cap-share__toast" aria-live="polite"></span>';

    block.parentNode.insertBefore(btn, block.nextSibling);

    var toast = btn.querySelector('.cap-share__toast');
    function showToast(msg) {
      toast.textContent = msg;
      toast.classList.add('is-visible');
      setTimeout(function () { toast.classList.remove('is-visible'); }, 2200);
    }

    btn.addEventListener('click', function () {
      var data = { title: productTitle(), url: cleanUrl() };
      if (navigator.share) {
        navigator.share(data).catch(function () { /* usuario canceló: ignorar */ });
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(data.url).then(
          function () { showToast('Enlace copiado'); },
          function () { showToast(data.url); }
        );
      } else {
        showToast(data.url);
      }
    });
  }

  function init() { injectCSS(); build(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  // Reintento por si los acordeones se construyen justo después, y en view-transitions.
  setTimeout(init, 400);
  document.addEventListener('shopify:section:load', init);
})();
